import React from 'react';
import { render } from 'react-dom';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eb/site-analytics';
// import 'eventbrite_design_system/css/eds.css';
import './app.scss';
import App from './app';
import serverData from './__mocks__/serverData';
import { getLocaleOverride, setupAsync, getParentLocale } from '@eb/i18n';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || serverData;
const parentLocale = getParentLocale(
    getLocaleOverride() || props.env.localeInfo.locale,
);

if (parentLocale !== 'en_US') {
    setupAsync({
        parentLocale,
        translations: /* webpackChunkName: "i18n-translation" */ import(
            `./i18n/translations/${parentLocale}.json`
        ),
    });
}

// render app with server props to the DOM
render(<App {...props} />, document.getElementById('root'));

// set up initial GA tracking
initDimensionsFromState(props);
trackInitialPageView(props.gaSettings);
